<template>
  <div class="navigation-sp-wrapper" id="js-navigation-header">
    <ul class="navigation-sp">
      <li class="navigation-sp-item">
        <a class="navigation-sp-item-inner" href="/">企業サイト トップ</a>
      </li>

      <footer-sp-navigation-about></footer-sp-navigation-about>

      <li class="navigation-sp-item">
        <a class="navigation-sp-item-inner" href="/business/">事業案内</a>
      </li>
      <li class="navigation-sp-item">
        <a class="navigation-sp-item-inner" href="/csr/">CSR</a>
      </li>
      <li class="navigation-sp-item">
        <a class="navigation-sp-item-inner" href="/news/">ニュース</a>
      </li>

      <footer-sp-navigation-ir></footer-sp-navigation-ir>

      <footer-sp-navigation-travel></footer-sp-navigation-travel>

      <li class="navigation-sp-item">
        <a
          class="navigation-sp-item-inner"
          href="https://career.tabikobo.com/guideline/"
          >採用情報</a
        >
      </li>

      <li class="navigation-sp-item">
        <a
          class="navigation-sp-item-inner"
          href="https://www.tabikobo.com/policy/"
          >プライバシーポリシー</a
        >
      </li>
      <li
        class="navigation-sp-close"
        id="js-navigation-sp-close"
        v-on:click="close"
      >
        CLOSE
        <i class="icon-close"></i>
      </li>
    </ul>
  </div>
</template>

<script>
import jQuery from "jquery";
const $ = jQuery;

import FooterSpNavigationAbout from "@/components/molecules/FooterSpNavigationAbout";
import FooterSpNavigationIr from "@/components/molecules/FooterSpNavigationIr";
import FooterSpNavigationTravel from "@/components/molecules/FooterSpNavigationTravel";

export default {
  components: {
    FooterSpNavigationAbout,
    FooterSpNavigationIr,
    FooterSpNavigationTravel,
  },
  methods: {
    close: function () {
      $("#js-navigation-sp-mask").removeClass("is-fixed");
      $("#js-navigation-button").removeClass("is-open");
      $("#js-navigation-header")
        .removeClass("is-scroll")
        .removeClass("is-open");
      $("#js-wrapper").removeClass("is-freeze").css({ top: "" });
    },
  },
};
</script>
